import React from 'react'
import { Segment, Container, Header, Icon, Button, Grid, GridColumn, Image } from 'semantic-ui-react'
import { Link } from 'react-router-dom'

const HomePage = () => {
    return <Segment inverted textAlign='center' vertical className='masthead'>

        <Container text>

            <Image src='/assets/prymera.png' size="medium" centered />
            <br />
            <br />
            <Header as='h3' inverted>
                <Icon name="calendar minus outline" />
                Estimado Cliente, con el compromiso asumido en esta situación de
                Emergencia, ponemos a tu disposición  la opción de reprogramar tu préstamo
                actual:
            </Header>

            <Header size="huge" inverted content='¿Tiene dificultad para pagar tus cuotas?' />
            <br />
            <Grid columns={2} divided>
                <GridColumn>
                    <Button as={Link} to='/reprogramar'
                        size='huge' inverted content='Sí, tengo dificultad' />

                </GridColumn>
                <GridColumn>

                    <Button as={Link} to='/puntos-pago'
                        size='huge' inverted content='No, sí puedo pagar' />
                </GridColumn>

            </Grid>
        </Container>
    </Segment>
}

export default HomePage
